import { useNavigate } from 'react-router-dom'
import { ArrowRightStartOnRectangleIcon } from '@heroicons/react/24/outline'
import { useSiteStore } from '@stores/siteStore'
import { useAuthStore } from '@stores/authStore'
import ThemeToggle from './ThemeToggle'

export default function Header() {
  const activeSite = useSiteStore((s) => s.sites.find((site) => site.id === s.activeSiteId))
  const logout = useAuthStore((s) => s.logout)
  const navigate = useNavigate()

  function handleLogout() {
    logout()
    navigate('/login', { replace: true })
  }

  return (
    <header className="flex h-16 items-center justify-between border-b border-gray-200 bg-white px-6 dark:border-gray-700 dark:bg-gray-900">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">SEO Dashboard</h2>
        {activeSite && (
          <p className="text-xs text-gray-500 dark:text-gray-400">{activeSite.url}</p>
        )}
      </div>
      <div className="flex items-center gap-4">
        <ThemeToggle />
        <div className="text-right text-sm">
          <p className="font-medium text-gray-700 dark:text-gray-300">Sven Thirion</p>
          <p className="text-gray-500 dark:text-gray-400">sventhirion.com</p>
        </div>
        <button
          onClick={handleLogout}
          title="Sign out"
          className="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-700 dark:hover:text-gray-200 transition-colors"
        >
          <ArrowRightStartOnRectangleIcon className="h-5 w-5" />
        </button>
      </div>
    </header>
  )
}
